import { Toast, Tooltip } from './_bootstrap';
import slick from 'slick-carousel';
import updateTabIndices, { handleSlideNavigation } from './slide-navigation';
(() => {
	
	Drupal.behaviors.header_height = {
		attach: function (context) {
				once('set-header-height', '.page__header', context).forEach(function(element) {
				let navBar = document.querySelector('.navbar');
				let pageHeading = null;
				let totalHeight = 0;
				if(document.querySelector('article.section--full')) {
						let toolbarHeight = document.documentElement.style.getPropertyValue('--drupal-displace-offset-top');
						toolbarHeight = toolbarHeight.replace('px', '');
						toolbarHeight = parseInt(toolbarHeight);
						if(document.querySelector('article.section--full')) {
							pageHeading = document.querySelector('article.section--full .paragraph h2');
							let pageHeadingHeight = pageHeading.clientHeight;
							let headingAndNavHeight = pageHeadingHeight + navBar.clientHeight;
							totalHeight += headingAndNavHeight;
							totalHeight += 10;
							document.documentElement.style.setProperty('--headerheight', totalHeight + 'px');
						}
				}
				
				document.documentElement.style.setProperty('--headerheight', totalHeight + 'px');
			});
			once('set-prev-index', '.slide-control-prev', context).forEach(function(prevbtn) {
				let currentSlide = document.querySelector('.field--name-field-slides > .field__item.active').getAttribute('data-slide-index');
				if (currentSlide > 0) {
					prevbtn.setAttribute('data-slide-index', parseInt(currentSlide) - 1);
				} else {
					prevbtn.setAttribute('data-slide-index', 0);
				}
			});
			once('set-next-index', '.slide-control-next', context).forEach(function(slide) {
				let totalSlides = document.querySelectorAll('.field--name-field-slides > .field__item').length;
				let currentSlide = document.querySelector('.field--name-field-slides > .field__item.active').getAttribute('data-slide-index');
				if(currentSlide < totalSlides - 1) {
					slide.setAttribute('data-slide-index', parseInt(currentSlide) + 1);
				}
			});
			once('set-prev-sidebar-section-state', '.sidebar-menu-item', context).forEach(function(item) {
				if(!item.classList.contains('active')) {
					return;
				} else {
					let prevItem = item.previousElementSibling;
					if(!prevItem.matches('.sidebar-menu-item')) {
						// this will be used to hide the previous section button if there is no previous section
						if(document.querySelector('.slide-navigation-container')) {
								document.querySelector('.slide-navigation-container').classList.add('first-section');
								let previousSectionButton = document.querySelector('.slide-navigation-container .previous-section-button');
								if(previousSectionButton !== null) {
									previousSectionButton.setAttribute('aria-hidden', true);
									previousSectionButton.setAttribute('tabindex', '-1');
								}
								return;
						}
					} else {
							if(prevItem.querySelector('.sidebar-item-index') === null) {
								return;
							} else {
									let prevSectionAnchor = prevItem.querySelector('a');
									let prevSectionLastSlideId = prevSectionAnchor.dataset.lastSlideId;
									let prevSectionHref = prevItem.querySelector('a').getAttribute('href');
									prevSectionHref += '#slide-' + prevSectionLastSlideId;
									let button = document.querySelector('.previous-section-button');
									if(button !== null) {
											button.setAttribute('href', prevSectionHref);
											for(let i = 0; i < button.childNodes.length; i++) {
												if(button.childNodes[i].nodeType === Node.TEXT_NODE) {
													button.childNodes[i].nodeValue = Drupal.t('Back');
												}
											}
									}
								}
						}
				}
		});	
			once('set-next-sidebar-section-state', '.sidebar-menu-item', context).forEach(function(item) {
				if(!item.classList.contains('active')) {
					return;
				} else {
					let nextItem = item.nextElementSibling;
					if(!nextItem.matches('.sidebar-menu-item')) {
						// this will be used to hide the next section button if there is no next section
						// and to show the finish button
						if(document.querySelector('.slide-navigation-container')) {
							document.querySelector('.slide-navigation-container').classList.add('last-section');
							return;
						}
					} else {
						if(nextItem.querySelector('.sidebar-item-index') === null) {
							return;
						} else {
								let nextItemIndex = nextItem.querySelector('.sidebar-item-index');
								let nextSectionHref = nextItem.querySelector('a').getAttribute('href');
								let nextButtonText = '<span class="light-fw">' + Drupal.t('Section', {}, {context: 'Javascript'}) + '&nbsp;' + nextItemIndex.textContent + ':</span> ' + nextItem.querySelector('.sidebar-item-title').textContent;
								let button = document.querySelector('.next-section-button');
								if(button !== null) {
									button.innerHTML = nextButtonText;
									button.setAttribute('href', nextSectionHref);
								}
							}
					}
				}
			});
			once('set-next-section-button-listener', '.slide-control-next', context).forEach(function (button) {
        var prevBtn = document.querySelector('.slide-control-prev');
        button.addEventListener('click', function (event) {
          if (prevBtn.classList.contains('btn-hidden')) {
            prevBtn.classList.remove('btn-hidden');
					}
				});
			});
			once('set-prev-section-button', '.slide-control-prev', context).forEach(function(button) {
				let slides = document.querySelectorAll('.field--name-field-slides > .field__item');
				slides.forEach(function(slide) {
					// figure out if the first slide is the active slide
					// if so, then first we will remove the back button (that would goes to the previous section)
					if(slide.classList.contains('active')) {
						if(slide.getAttribute('data-slide-index') === '0') {
							// this can cause a bug when there is a slide hash in the window location
							// so we will check if the window location hash is not empty
							button.classList.add('btn-hidden');
							// then we will show the previous section button
							let previousSectionButton = document.querySelector('.slide-navigation-container .previous-section-button');
							if(previousSectionButton !== null) {
								previousSectionButton.classList.remove('btn-hidden');
							}
						}
					}
				});
			});
			// slick.js will disable the prev btn when it is on the first slide
			// we're going to add a listener that checks if the user clicks any of the slick-dots
			// or the next button. 
			once('listener-slick-dots-slick-next', '.paragraph--type--full-width-carousel .dots-and-arrows', context).forEach(function(element) {
				let carousel = element.closest('.paragraph--type--full-width-carousel');
				element.addEventListener('click', function(event) {
					let prevBtn = carousel.querySelector('.slick-prev');
						if(prevBtn.classList.contains('btn-hidden')) {
						prevBtn.classList.remove('btn-hidden');
					}
				});
			});
			once('listener-slick-dots-aria', '.paragraph--type--full-width-carousel .dots-and-arrows', context).forEach(function(dots) {
				// first we wait a bit for slick to update the DOM
				window.setTimeout(function() {
					let allDots = document.querySelectorAll('.dots-and-arrows li');
					// this will set the aria-selected attributes on load. 
					// then we will use the afterChange method on slick to update this when the slides change
					allDots.forEach(function(dot) {
						let dotAnchor = dot.querySelector('a');
						dotAnchor.setAttribute('role', 'button');
						if(dot.classList.contains('slick-active')) {
							dotAnchor.setAttribute('aria-selected', true);
							let dotCurrentStatus = dotAnchor.querySelector('.current');
							if(dotCurrentStatus !== null) {
								dotCurrentStatus.textContent = 'Current item';
							}
						} else {
							dotAnchor.setAttribute('aria-selected', false);
						}	
					});
				}, 1000);
			});
			// now we have to account for the case where someone goes back to the first slide
			// so we set a click event listener on the prev button
			once('set-prev-section-button-listener', '.slide-control-prev', context).forEach(function(button) {
				button.addEventListener('click', function(event) {
					if(this.getAttribute('data-slide-index') === '0') {
						document.querySelector('.slide-control-prev').classList.add('btn-hidden');
					}
				});
			});
			once('set-slide-nav-listeners', '.slide-control-prev, .slide-control-next', context).forEach(function(button) {
				button.addEventListener('click', function(event) {
					let slideIndex = parseInt(this.getAttribute('data-slide-index'));
					handleSlideNavigation(event, slideIndex, context);
					updateTabIndices();
					updateLanguageTogglerHash();
				});
			});
			once('set-suite-name-in-finish-modal', '.finish-button', context).forEach(function(button) {
				button.addEventListener('click', function(event) {
					event.preventDefault();
					let suiteName = document.querySelector('.suite-information .suite-title').textContent;
					let modal = document.querySelector('#finish-modal');
					let suiteNameModal = modal.querySelector('#suite-name');
					suiteNameModal.textContent = suiteName + '.';
				});
			});
		}
	};
	
	// if one resizes the window, going from wide to more narrow,
	// since the slick-track has an inline height set, it can no longer be 100% height
	// so we have this window listener, debounce function, and updateSlickTrackHeight function
	// to make sure the slick-track remains 100% height

	Drupal.behaviors.window_resize_home_hero_full_height = {
		attach: function(context) {
			window.setTimeout(function() {
				if(jQuery('.paragraph--type--home-hero .slick-track', context).length) {
					updateSlickTrackHeight();
					// document.addEventListener('DOMContentLoaded', updateSlickTrackHeight);
					function updateSlickTrackHeight() {
						// Get all slick track elements
						const slickTracks = document.querySelectorAll('.slick-track');
						slickTracks.forEach(track => {
								// Get the parent slider container
								const sliderContainer = track.closest('.slick-slider');
								
								if (sliderContainer) {
										// Remove the inline height style and set it to 100%
										track.style.removeProperty('height');
										track.style.height = '100%';
										// Force a reflow of the slider
										jQuery(track).closest('.slick-slider').slick('setPosition');
										track.style.height = `${sliderContainer.offsetHeight}px`;
								}
						});
					}
					// Debounce function to prevent excessive updates
					function debounce(func, wait) {
						let timeout;
						return function executedFunction(...args) {
								const later = () => {
										clearTimeout(timeout);
										func(...args);
								};
								clearTimeout(timeout);
								timeout = setTimeout(later, wait);
						};
					}
					const debouncedUpdate = debounce(updateSlickTrackHeight, 250);
	
					window.addEventListener('resize', function() {
						// Function to update slick track height
						debouncedUpdate();
					});
				}
			}, 1500);
		}
	};

	Drupal.behaviors.initialize_carousels = {
		attach: function (context) {
			if(jQuery('.paragraph--type--full-width-carousel, .paragraph--type--text-carousel', context).length) {
				jQuery(once('initialize-full-width-carousel', '.field--name-field-carousel-item', context)).each(function(index, element) {
					let paragraphId = jQuery(element).closest('.paragraph--type--full-width-carousel, .paragraph--type--text-carousel').attr('id');
					let appendDots = '#' + paragraphId + ' .dots-and-arrows';
					jQuery(element).slick({
						autoplay: false,
						dots: true,
						arrows: true,
						infinite: false,
						speed: 300,
						slidesToShow: 1,
						slidesToScroll: 1,
						appendDots: appendDots,
						customPaging: function (slick, index) {
							var slideLabel = slick.$slides.eq(index).find('.paragraph[data-slide-label]').attr('data-slide-label');
							let markup = '';
							if (slideLabel) {
								markup = '<a><span aria-hidden="true">' + slideLabel + '</span>';
								markup += '<span class="sr-only">' + Drupal.t('Go to slide') + ' ' + (index + 1) + '</span>';
								markup += '<span class="current sr-only"></span>';
								markup += '</a>';
							} else {
								markup = '<a><span aria-hidden="true">' + (index + 1) + '</span>';
								markup += '<span class="sr-only">' + Drupal.t('Go to slide') + ' ' + (index + 1) + '</span>';
								markup += '<span class="current sr-only"></span>';
								markup += '</a>';
							}
							return markup;
						},
					});
					jQuery(element).on('afterChange', function(event, slick, currentSlide) {
						let activeDot = document.querySelector('.slick-dots li.slick-active a');
						if(activeDot) {
							activeDot.setAttribute('aria-selected', true);
							activeDot.focus();
							let activeDotStatus = activeDot.querySelector('.current');
							if(activeDotStatus) {
								activeDotStatus.textContent = 'Current item';
							}
							let inactiveDots = document.querySelectorAll('.slick-dots li:not(.slick-active) a');
							inactiveDots.forEach(function(dot) {
								let dotStatus = dot.querySelector('.current');
								if(dotStatus) {
									dotStatus.textContent = '';
								}
								dot.setAttribute('aria-selected', false);
							});
						}
					});
				});
			} else if(jQuery('.field--name-field-carousel-item', context).length) {
				jQuery(once('initialize-carousel', '.field--name-field-carousel-item', context)).slick({
					autoplay: false,
					dots: false,
					arrows: true,
					infinite: false,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1,
				});
			}
			if(jQuery('.field--name-field-carousel-images', context).length) {
				// this is the homepage slideshow
				jQuery(once('initialize-carousel-images', '.field--name-field-carousel-images', context)).slick({
					autoplay: true,
					dots: false,
					arrows: false,
					infinite: true,
					speed: 1400,
					autoplaySpeed: 4500,
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: true,
				});
				const $slider = jQuery('.field--name-field-carousel-images');
				const $pauseButton = jQuery('<button class="slick-pause-btn">' + Drupal.t('Pause') + '</button>');
				const $playButton = jQuery('<button class="slick-play-btn">' + Drupal.t('Play') + '</button>');
				if(document.querySelector('.field--name-field-carousel-images .slick-pause-btn') == null) {
					jQuery('.field--name-field-carousel-images').append($pauseButton).append($playButton);
				}				
				// Initially hide the play button
				$playButton.hide();
				
				// Pause button click handler
				$pauseButton.on('click', function() {
						$slider.slick('slickPause');
						$pauseButton.hide();
						$playButton.show();
				});
				
				// Play button click handler
				$playButton.on('click', function() {
						$slider.slick('slickPlay');
						$playButton.hide();
						$pauseButton.show();
				});
			}
			once('set-home-carousel-slide-height', '.field--name-field-carousel-images', context).forEach(function(carousel) {
				window.setTimeout(function() {					
					let parentSlide = document.querySelector('.field--name-field-carousel-images .slick-track');
					// get the height of parentSlide
					let parentSlideHeight = parentSlide.clientHeight;
					// just set the css height as the height, so that 100% height for children will work 
					parentSlide.style.height = parentSlideHeight + 'px';
				}, 2000);
			});
		}
	};
	Drupal.behaviors.keyboardNavigation = {
		attach: function(context) {
			once('set-keyboard-navigation', '.field--name-field-slides', context).forEach(function(slide) {
				// some things must be navigated to using left and right
				// arrows but when the user tabs to them and hits enter, 
				// they dont get the same functionality. so enter keydowns need to trigger click events
				let navPills = document.querySelectorAll('.nav-pills .nav-link');
				let slickDots = document.querySelectorAll('.slick-dots li a');
				// combine them into one array using spread operator
				let allButtons = [...navPills, ...slickDots];
				allButtons.forEach(function(button) {
					button.addEventListener('keydown', function(event) {
						if(event.key === 'Enter') {
							event.preventDefault();
							button.focus();
							button.click();
						}
					});
				});
				// slick is doing an annoying thing where the tabindex is set to -1
				// on all non-active slides
				// so we want to override that.
				let $slickSlider = jQuery('.slick-slider');
				$slickSlider.on('afterChange', function(event, slick, currentSlide) {
					let slickDots = document.querySelectorAll('.slick-dots li a');
					window.setTimeout(function() {
						slickDots.forEach(function(dot) {
							dot.setAttribute('tabindex', '0');
						});
					}, 500);
				});
			});
		}
	};
	Drupal.behaviors.translateOnLoad = {
		attach: function(context) {
			once('set-translate-on-load', 'html', context).forEach(function(html) {
				window.addEventListener('load', function() {				
					let language = html.getAttribute('lang');
					let nextBtn = document.querySelector('.slide-navigation-container .slide-control-next');
					let prevBtn = document.querySelector('.slide-navigation-container .slide-control-prev');
					let nextSectionBtn = document.querySelector('.next-section-button');
					let finishBtn = document.querySelector('.finish-button');

					// check if the current lang contains the string "en"
					if(language.includes('en')) {
						// probably do nothing
					} else {
						if(nextBtn !== null) {		
							for(let i = 0; i < nextBtn.childNodes.length; i++) {
								if(nextBtn.childNodes[i].nodeType === Node.TEXT_NODE) {
									nextBtn.childNodes[i].nodeValue = "Próximo";
								}
							}
						}
						if(prevBtn !== null) {
							for(let i = 0; i < prevBtn.childNodes.length; i++) {
								if(prevBtn.childNodes[i].nodeType === Node.TEXT_NODE) {
									prevBtn.childNodes[i].nodeValue = "Atrás";
								}
							}
						}
						if(finishBtn !== null) {
							for(let i = 0; i < finishBtn.childNodes.length; i++) {
								if(finishBtn.childNodes[i].nodeType === Node.TEXT_NODE) {
									finishBtn.childNodes[i].nodeValue = "Finalizar";
								}
							}
						}
					}
				});
			});
		}
	}
	Drupal.behaviors.handleJumpLinks = {
		attach: function(context) {
			// this ensures that if a user goes to a url such as /learning-modules/make-math-playful#new-video
			// wherin #new-video is an id on an element deep down the slides
			once('handle-window-hash', '.field--name-field-slides', context).forEach(function(slide) {
				function handleHash() {
					const hashValue = window.location.hash.substring(1);
					if(hashValue) {
						// const hashValue = window.location.hash.substring(1);
						const syntheticButton = document.createElement('button');
						syntheticButton.setAttribute('target', hashValue);
						// Create a synthetic event and element
						const syntheticEvent = {
							type: 'click',
							target: syntheticButton,
							currentTarget: syntheticButton,
							preventDefault: function() {},
							stopPropagation: function() {}
						};					
						// if the user clicked the skip to main content link, hashValue will be 'main-content'
						if(hashValue !== 'main-content') {
							let targetElement = document.getElementById(hashValue);
							if(targetElement !== null) {
								// nb: closest traverses up the DOM tree
								let slide = targetElement.closest('.field--name-field-slides .field__item[data-slide-index]');
								let slideIndex = null;
								if(slide) {
									let slideIndex = slide.getAttribute('data-slide-index');
									handleSlideNavigation(syntheticEvent, slideIndex, context);
									updateTabIndices();
									updateLanguageTogglerHash();
								}
								// lastly, we want to show the slide-control-prev button
								if(slideIndex !== null && slideIndex > 0) {
									if(document.querySelector('.slide-control-prev').classList.contains('btn-hidden')) {
										document.querySelector('.slide-control-prev').classList.remove('btn-hidden');
									}
								} else if(slideIndex !== null && slideIndex === 0) {
									if(!document.querySelector('.slide-control-prev').classList.contains('btn-hidden')) {
										document.querySelector('.slide-control-prev').classList.add('btn-hidden');
									}
								}
						} else {
							// this will deal with an edge case where the user has gone to a url with a hash
							// but that hash doesn't correspond to any paragraph id
							// lord willing, it doesnt cause more bugs!!!
							if(!document.querySelector('.slide-control-prev').classList.contains('btn-hidden')) {
								document.querySelector('.slide-control-prev').classList.add('btn-hidden');
							}
						}
					}
				}
			}
			handleHash();
			window.addEventListener('hashchange', handleHash);
			});
		}
	};
	Drupal.behaviors.videoDescriptionSwap = {
		attach: function(context) {
			// jQuery('.video-with-description').attr('aria-hidden', true);
			jQuery('.video-with-description').attr('aria-hidden', true);
			jQuery('.video-swap-handler .headphones-icon').hide();
			once('set-video-swap-handler', '.video-swap-handler', context).forEach(function(element) {
				jQuery(element, context).on('click', function(event) {
					event.preventDefault();
					toggleVideos(event.target.closest('.video-container'));
				});
				jQuery(element, context).on('keydown', function(event) {
					if(event.key == 'Enter') {
						event.preventDefault();
						toggleVideos(jQuery(this).parents('.video-container'));
					}
				});
		});
		}
		
	};
	Drupal.behaviors.basicPage = {
		attach: function(context) {
			let setHeaderHeight = function() {
				let navBar = document.querySelector('nav.navbar');
				let navHeight = navBar.clientHeight;
				// set the root variable headerheight to the navHeight
				// do the same for header.page__header
				let pageHeader = document.querySelector('header.page__header');
				let pageHeaderHeight = pageHeader.clientHeight;
				let totalPageHeaderHeight = navHeight + pageHeaderHeight;

				document.documentElement.style.setProperty('--pageheaderheight', totalPageHeaderHeight + 'px');
			}
			
			window.addEventListener('load', function() {
				once('set-header-height', '.basic-page', context).forEach(function(page) {
					setHeaderHeight();
				});
			});
			window.addEventListener('resize', function() {
				setHeaderHeight();
			});
		}
	};
	Drupal.behaviors.resourceItemHover = {
		attach: function(context) {
			function mouseOverResource(item, event) {
				let resourceItem = event.target.closest('.paragraph--type--resource-item');
				resourceItem.classList.add('hover');
				item.setAttribute('aria-expanded', true);
			}	
			function mouseOutResource(item, event) {
				let resourceItem = event.target.closest('.paragraph--type--resource-item');
				resourceItem.classList.remove('hover');
				item.removeAttribute('aria-expanded');
			}
			function clickResource(event) {
				let resourceItem = event.target.closest('.paragraph--type--resource-item');
				resourceItem.classList.toggle('hover');
				if(resourceItem.classList.contains('hover')) {
					resourceItem.setAttribute('aria-expanded', true);
				} else {
					resourceItem.removeAttribute('aria-expanded');
				}
			}
			once('set-other-resource-hover-listeners', '.field--name-field-resource-ref .resource--teaser', context).forEach(function(item) {
				item.addEventListener('mouseover', function(event) {
					mouseOverResource(item, event);
				});
				item.addEventListener('mouseout', function(event) {
					mouseOutResource(item, event);
				});
				item.addEventListener('click', function(event) {
					clickResource(item, event);
				});
			});
			once('set-resource-hover-listeners', '.field--name-field-paragraph-resources .resource--teaser', context).forEach(function(item) {
				item.addEventListener('mouseover', function(event) {
					mouseOverResource(item, event);
				});
				item.addEventListener('mouseout', function(event) {
					mouseOutResource(item, event);
				});
				item.addEventListener('click', function(event) {
					clickResource(event);
				});
			});
		}
	}
	Drupal.behaviors.resourceLibrary = {
		attach: function(context) {
			once('set-resource-library-nav-listeners', '.resource-library-nav-tabs .tab', context).forEach(function(tab) {
				let selfStudyID = 'self-study-pane';
				let facilitatorID = 'facilitator-resources-pane';
				
				// not clear why, but block 1 wasn't available in the dom without this timeout
				window.setTimeout(function(){
					// first we want to set aria-selected="true"
					if(tab.id == 'self-study') {
						tab.classList.add('active');
						tab.setAttribute('aria-controls', selfStudyID );
						// tab.setAttribute('aria-selected', true);
						if(document.querySelector('.block-views-blockfilterable-resource-library-block-1')) {
							document.querySelector('.block-views-blockfilterable-resource-library-block-1').setAttribute('id', selfStudyID);
							document.querySelector('.block-views-blockfilterable-resource-library-block-1').setAttribute('aria-labelledby', 'self-study');
						}
					} else if(tab.id == 'facilitator-resources') {
						tab.setAttribute('aria-controls', facilitatorID);
						// tab.setAttribute('aria-selected', true);
						if(document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2')) {
							document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').setAttribute('id', facilitatorID);
							document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').setAttribute('aria-labelledby', 'facilitator-resources');
						}
					}
					tab.addEventListener('keydown', function(event){
						let thisButtonId = event.target.id;
						if(event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
							event.preventDefault();	
							let theOtherButtonId;
							if (thisButtonId === 'self-study') {
								theOtherButtonId = 'facilitator-resources';
							} else {
								theOtherButtonId = 'self-study';
							}
							document.getElementById(theOtherButtonId).click();
							document.getElementById(theOtherButtonId).focus();
						}
					});
					tab.addEventListener('click', function(event) {
						// get the id
						let id = tab.id;
						let allTabs = document.querySelectorAll('.resource-library-nav-tabs .tab');
						allTabs.forEach(function(tab) {
							tab.setAttribute('aria-selected', false);
							tab.classList.remove('active');
						});
						
						if(id == 'self-study') {
							tab.setAttribute('aria-selected', true);
							if(document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1')) {
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1').classList.add('show');
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1').setAttribute('aria-hidden', false);
							}
							if(document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2')) {
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').classList.remove('show');
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').setAttribute('aria-hidden', true);
							}
							tab.classList.add('active');
						} else if(id == 'facilitator-resources') {
							tab.setAttribute('aria-selected', true);
	
							if(document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1')) {
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1').classList.remove('show');
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-1').setAttribute('aria-hidden', true);
							}
							if(document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2')) {
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').classList.add('show');
								document.querySelector('.block--ems-radix-views-block--filterable-resource-library-block-2').setAttribute('aria-hidden', false);
							}
							tab.classList.add('active');
						}
						// push the history state of this tab
						if(history.replaceState) {
							history.replaceState(null, null, '#' + id);
						}
						updateLanguageTogglerHash();
					});
				}, 1000);
				
			});
			once('close-all-details', '.view-filterable-resource-library', context).forEach(function(view) {
				// this closes details elements when the user clicks outside of them
				window.addEventListener('click', function(event) {
					let allDetails = document.querySelectorAll('.view-filterable-resource-library form .details-children details');
					allDetails.forEach(function(detail) {
						if (!detail.contains(event.target)) {
							detail.removeAttribute('open');
							let summary = detail.querySelector('summary');
							summary.setAttribute('aria-expanded', false);
						}
					});
				});
			});
			//shows the details elements for a topic or resource type once the button is clicked
			once('set-check-number', '.view-filterable-resource-library .views-exposed-form', context).forEach(function(form) {
				let allDetails = document.querySelectorAll('.view-filterable-resource-library form details');
				allDetails.forEach(function(detail) {
					if(detail.querySelector('.view-filterable-resource-library form input[type="checkbox"]') === null) {
						// this details element has zero checkboxes
						// which would happen if a filter was applied to a different facet
						// and that excludes this particular details facet
						detail.classList.add('disabled');
						return;
					} else if(detail.querySelector('.view-filterable-resource-library form input[type="checkbox"]:checked') === null) {
						if(detail.classList.contains('disabled')) {
							detail.classList.remove('disabled');
						}
						return;
					} else {
						if(detail.classList.contains('disabled')) {
							detail.classList.remove('disabled');
						}
						let checkedCheckboxes = detail.querySelectorAll('.view-filterable-resource-library form input[type="checkbox"]:checked');
						let summary = detail.querySelector('summary');
						let summaryNumber = null;
						if(summary.querySelector('.summary') === null) {
							summaryNumber = document.createElement('span');
							summaryNumber.classList.add('summary');
							summary.appendChild(summaryNumber);
						} else {
							summaryNumber = summary.querySelector('.summary');
						}
						let numString = '(' + checkedCheckboxes.length + ')';
						summaryNumber.textContent = numString;
					}
				});
			});
			once('sync-resource-library-bef-forms', '.bef--secondary > summary[role="button"]', context).forEach(function(btn) {
				btn.addEventListener('click', function(event) {
					let form = btn.closest('.views-exposed-form');
					let $filters = jQuery(form).find('.views-exposed-form__filters');
					jQuery($filters).toggleClass('active');
				});
			});
			once('resource-bef-checkboxes', '.children-toggler', context).forEach(function(element) {
				element.addEventListener('click', function(event) {
					jQuery(event.target).toggleClass('active');
					let parent = element.closest('.bef-grouping');
					let children = parent.querySelector('.bef-children');
					jQuery(children).toggleClass('active');
				});
				// we're also going to use this same code to make sure that any active bef-children stay open on mobile
				let parent = element.closest('.bef-grouping');
				if (!parent) {
					return;
				} else {
					let relatedChildren = parent.querySelector('.bef-children');
					if (!relatedChildren) {
						return;
					} else {
						let checkedInputs = relatedChildren.querySelectorAll('input[type="checkbox"]:checked');
						if (checkedInputs.length > 0) {
							// if there are checked inputs, we want to ensure the .bef-children is visible
							jQuery(relatedChildren).addClass('active');
							jQuery(element).addClass('active');
							// also set the aria-expanded to true
							element.setAttribute('aria-expanded', 'true');
						}
					}
				}
			});
			once('search-toggle-active-state', '.views-exposed-form__filters .form-actions', context).forEach(function(element) {
				// we are going to have two of these functions
				// this first one is for the search button
				element.addEventListener('click', function(event) {
					let filtersParent = element.closest('.views-exposed-form__filters');
					let view = element.closest('.views-exposed-form');
					let summaryBtn = filtersParent.querySelector('.bef--secondary > summary');
					let befSecondary = filtersParent.querySelector('.bef--secondary');
					if(view.classList.contains('search-active')) {
						view.classList.remove('search-active');
					} else {
						view.classList.add('search-active');
						let isOpen = befSecondary.getAttribute('open');
						if(isOpen !== null) {
							befSecondary.removeAttribute('open');
							summaryBtn.setAttribute('aria-expanded', false);
						} 
					}
					});
				}
				
			);
			once('search-toggle-active-state-duplicate', '.views-exposed-form__filters .bef--secondary > summary', context).forEach(function(element) {
				// the second version of this is for the details toggler which
				// opens the .details-wrapper
				element.addEventListener('click', function(event) {
					// let befSecondary = event.target.closest('.bef--secondary');
					if(!element.classList.contains('active')) {
						let filtersParent = element.closest('.views-exposed-form__filters');
						let view = element.closest('.views-exposed-form');
						// let summaryBtn = filtersParent.querySelector('.bef--secondary > summary');
						if(view.classList.contains('search-active')) {
							view.classList.remove('search-active');
						} else {
							
						}
					}
					});
				}
			);
			once('close-filters-on-load', '.views-exposed-form__filters', context).forEach(function(element) {
				window.addEventListener('load', function(e) {
					if(window.innerWidth < 992) {
						let allBefSecondary = document.querySelectorAll('.bef--secondary');
						allBefSecondary.forEach(function(bef) {
							let isOpen = bef.getAttribute('open');
							let summaryBtn = bef.querySelector('summary');
							if(isOpen !== null) {
								bef.removeAttribute('open');
								summaryBtn.setAttribute('aria-expanded', false);
							}
						}); 
					} 
				}); 
				window.addEventListener('resize', function(e) {
					if(window.innerWidth < 992) {
						let allBefSecondary = document.querySelectorAll('.bef--secondary');
						allBefSecondary.forEach(function(bef) {
							let isOpen = bef.getAttribute('open');
							let summaryBtn = bef.querySelector('summary');
							if(isOpen !== null) {
								bef.removeAttribute('open');
								summaryBtn.setAttribute('aria-expanded', false);
							}
						}); 
					}  else {
						let allBefSecondary = document.querySelectorAll('.bef--secondary');
						allBefSecondary.forEach(function(bef) {
							let isOpen = bef.getAttribute('open');
							let summaryBtn = bef.querySelector('summary');
							if(isOpen === null) {
								bef.setAttribute('open', true);
								summaryBtn.setAttribute('aria-expanded', true);
							}
						}); 
					}
				});
			});
			once('set-search-state-after-ajax', '.views-exposed-form__filters', context).forEach(function(element) {
				let view = element.closest('.views-exposed-form');
				let searchInput = view.querySelector('.form-textfield');
				let befSecondary = element.querySelector('.bef--secondary');
				let summaryBtn = element.querySelector('.bef--secondary > summary');
				// check to see if there is a value in searchInput
				// if there is, we want to add the search-active class to the view like the code does above
				if(searchInput.value.trim() !== '') {
					if (window.innerWidth < 992) {
						view.classList.add('search-active');
						if(befSecondary !== null) {
							let isOpen = befSecondary.getAttribute('open');
							if(isOpen !== null) {
								befSecondary.removeAttribute('open');
								summaryBtn.setAttribute('aria-expanded', false);
							} 
						}
					}
					
				} else {
					view.classList.remove('search-active');
				}
			});
			once('keep-facets-open-on-mobile', 'details.form-item > summary', context).forEach(function(element) {
				if(window.innerWidth < 992) {
					let summarySpans = element.querySelectorAll('span.summary');
					let filterIsActive = false;
					summarySpans.forEach(function(span) {
						// let t = span.textContent;
						if(span.textContent.trim() !== '') { 
							filterIsActive = true;
						}
					});
					if(filterIsActive) {
						// to keep that filter open
						element.click();
					} else {
						// console.log('filter is not active');
					}
				}
			});
			
		}
	}
	Drupal.behaviors.handleResourceLibraryHash = {
		attach: function(context) {
			// first we are going to deal with the edge case where someone is already on the 
			// resource library page and has clicked a main menu nav to go to the other
			// resource library tab (eg they are looking at the steam suites tab and 
			// they click the resource library link in the main nav for the self-study resources)
			once('handle-main-nav-resource-library-click', '.navbar-nav .dropdown-item[href*="/resource-library"]', context).forEach(function(link) {
				link.classList.add('resource-library-link');
				link.addEventListener('click', function(event) {
					
					let hashValue = link.hash.substring(1);
					if(hashValue !== '' && window.location.pathname.includes('resource-library')) {
						// this first bit of code will close the mobile menu if it is open
						// because if someone was looking at one tab of the resource library
						// but they click a main menu link to go to the other one, the default
						// behavior is that the mobile menu will stay open
						let toggler = document.querySelector('.navbar-toggler');
						let facilitatorResourcesTab = document.querySelector('.resource-library-nav-tabs #facilitator-resources');
						let selfStudyTab = document.querySelector('.resource-library-nav-tabs #self-study');
						if(toggler.getAttribute('aria-expanded') === 'true') {
							toggler.click();
						}
						if(hashValue === 'facilitator-resources') {
							facilitatorResourcesTab.click();
							facilitatorResourcesTab.blur();
						} else if(hashValue.includes('self-study')) {
							selfStudyTab.click();
							selfStudyTab.blur();
						}
					}
					
				});
			});
			// now this will deal with the more common case 
			// where someone is on any other non-resource library page
			// and clicks one of the resource library links in the main nav
			once('handle-resource-library-hash', '.resource-library-nav-tabs', context).forEach(function(button) {
				const relativeUrl = window.location.pathname;
				const hashValue = window.location.hash.substring(1);
				if(hashValue !== '' && relativeUrl.toString().includes('resource-library')) {
					if(hashValue === 'facilitator-resources') {
						window.setTimeout(function() {
							document.querySelector('.resource-library-nav-tabs #facilitator-resources').click();
							document.querySelector('.resource-library-nav-tabs #facilitator-resources').blur();
						}, 1200);
					} else if(hashValue.includes('self-study')) {
						window.setTimeout(function() {
							document.querySelector('.resource-library-nav-tabs #self-study').click();
							document.querySelector('.resource-library-nav-tabs #self-study').blur();
						}, 1200);
					}
				}
			});
		}
	}
	Drupal.behaviors.befAjaxSubmit = {
    attach: function (context, settings) {
			once('resource-library-search', '.views-exposed-form__filters .form-textfield', context).forEach(function(input) {

 				input.addEventListener('keydown', function(event) {
          if (event.keyCode === 13) {
            event.preventDefault();
            
            var $form = jQuery(this).closest('form');
						if (Drupal.ajax && $form.length) {
							// find the submit button and trigger a click
							var $submitButton = $form.find('input[id*="submit-filterable"]');
							if ($submitButton.length) {
								$submitButton.click();
							}
						} 
          }
        });
      });
    }
  };
	Drupal.behaviors.linksInSlideBodyOpenInNewTab = {
		attach: function(context) {
			once('set-links-in-slide-body', '.field--name-field-slides .field__item div[id*="slide-"]', context).forEach(function(slideBody) {
				let links = slideBody.querySelectorAll('a');
				links.forEach(function(link) {
					if(link.classList.contains('btn-tertiary')) {
						// the jump links that go between slides will have this tertiary class
						// and we dont want those links to open in a new tab
						return;
					} else {
						if(link.getAttribute('href') !== null && link.getAttribute('target') === null) {
							link.setAttribute('target', '_blank');
						}
					}
					
				});
			});
		}
	}
	Drupal.behaviors.mobileMega = {
		attach: function(context) {
			once('set-mobile-mega', '.menu-category-grouping h3', context).forEach(function(e) {
				e.addEventListener('click', function(event) {
					event.preventDefault();
					event.stopPropagation();
					jQuery(event.target).toggleClass('active');
					let $dropdown = jQuery(this).siblings('.menu-category-children');
					if(window.innerWidth < 992 ) {
						$dropdown.slideToggle();
					}
				});
			});
			// if you widen the window from mobile, with the menu opened, things get weird
			// so we will close the menu when the window is resized
			window.addEventListener('resize', function() {
				let navbar = document.querySelector('.navbar-collapse');
				if(window.innerWidth > 992) {
					if(navbar.classList.contains('show')) {
						navbar.classList.remove('show');
					} else {
						return;
					}
				}
			});
		}
	}
	Drupal.behaviors.handleSectionWithOneSlide = {
		attach: function(context) {
			once('set-section-with-one-slide', 'body.node-type--section', context).forEach(function(section) {
				let childSlides = section.querySelectorAll('.field--name-field-slides > .field__item');

				if(childSlides.length === 1) {
					let nextSlideBtn = document.querySelector('.slide-control-next');
					let nextSectionBtn = document.querySelector('.next-section-button');
					nextSlideBtn.classList.add('btn-hidden');
					nextSectionBtn.classList.remove('btn-hidden');
				}
			});
		}
	};
	Drupal.behaviors.improveBootstrapNavTabs = {
		attach: function(context) {
				once('bootstrap-nav-tabs', '.paragraph--type--tabs', context).forEach(function(paragraph) {
					let tabs = paragraph.querySelectorAll('button[data-bs-toggle="pill"]');
					tabs.forEach(function(tab) {
						tab.addEventListener('keydown', function(event) {
							// this makes sure arrow up and down don't change tabs
							if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
								event.stopPropagation();
								event.stopImmediatePropagation();
							}
							if(event.key === 'ArrowDown') {
								event.preventDefault();
								let thisTabContent = tab.getAttribute('aria-controls');
								let thisTabContentElement = document.getElementById(thisTabContent);
								thisTabContentElement.focus();
							}
						});
					});
					// we are going to wait for the bootstrap js to do its thing
					// so we have this timeout
					// setting the tabindex in the field template did not work. 
					window.setTimeout(function() {
						tabs.forEach(function(tab) {
							if(tab.classList.contains('active')) {
								return;
							} else {
								tab.setAttribute('tabindex', '-1');
							}
						});
					}, 2000);
					let tabPanels = paragraph.querySelectorAll('.tab-pane');
					tabPanels.forEach(function(panel) {
						panel.addEventListener('keydown', function(event) {
							if(event.key === 'ArrowUp') {
								event.preventDefault();
								let thisTab = panel.getAttribute('aria-labelledby');
								let thisTabElement = document.getElementById(thisTab);
								thisTabElement.focus();
							}
						});
					});
			});
		}
	};
	// * Tooltip initialization, remove it if not necessary
	for (const tooltipElement of document.querySelectorAll(
		'[data-toggle="tooltip"]',
	)) {
		new Tooltip(tooltipElement);
	}

	// * Toast initialization, remove it if not necessary
	for (const toastElement of document.querySelectorAll(".toast")) {
		new Toast(toastElement);
	}
})();

const updateLanguageTogglerHash = function() {
	if(document.querySelector('.block--ems-radix-languageswitchercontent .links')) {
		let spanishButton = document.querySelector('.block--ems-radix-languageswitchercontent .links a[hreflang*="es"]');
		let englishButton = document.querySelector('.block--ems-radix-languageswitchercontent .links a[hreflang*="en"]');
		let currentHash = window.location.hash;

		if (spanishButton) {
			// first remove any existing hash
			spanishButton.href = spanishButton.href.replace(/#.*$/, '');
			if(currentHash !== '') {
				spanishButton.href = spanishButton.href + currentHash;
			}
		}
		if(englishButton) {
			englishButton.href = englishButton.href.replace(/#.*$/, '');
			if(currentHash !== '') {
				englishButton.href = englishButton.href + currentHash;
			}
		}
	}
}


window.addEventListener('DOMContentLoaded', (event) => {
	updateLanguageTogglerHash();
});

const toggleVideos = function(element) {
	let videoNoAudioDesc = jQuery(element).find('.video-no-description');
	let videoAudioDesc = jQuery(element).find('.video-with-description');
	let togglerButton = jQuery(element).find('.video-swap-handler');
	let headphonesIcon = jQuery(togglerButton).find('.headphones-icon');
	let audioIcon = jQuery(togglerButton).find('.audio-icon');
	if(jQuery(videoAudioDesc).attr('aria-hidden') === "true") {
		let iframe = jQuery(videoNoAudioDesc).find('iframe');
		let src = iframe.attr('src');
		iframe.attr('src', '');
		setTimeout(function() {
			iframe.attr('src', src);
		}, 500);
		jQuery(audioIcon).hide();
		jQuery(headphonesIcon).show();
		jQuery(videoNoAudioDesc).hide();
		jQuery(videoAudioDesc).attr('aria-hidden', false);
		jQuery(videoNoAudioDesc).attr('aria-hidden', true);
		jQuery(videoAudioDesc).show();
		jQuery(togglerButton).find('.video-handler-text').text(Drupal.t('Switch to video with standard audio track', {}, {context: 'Javascript'}));
		
	} else {
		let iframe = jQuery(videoAudioDesc).find('iframe');
		let src = iframe.attr('src');
		iframe.attr('src', '');
		setTimeout(function() {
			iframe.attr('src', src);
		}, 500);
		jQuery(headphonesIcon).hide();
		jQuery(audioIcon).show();
		jQuery(videoAudioDesc).hide();
		jQuery(videoNoAudioDesc).attr('aria-hidden', false);
		jQuery(videoAudioDesc).attr('aria-hidden', true);
		jQuery(videoNoAudioDesc).show();
		jQuery(togglerButton).find('.video-handler-text').text(Drupal.t('Switch to video with descriptive audio track', {}, {context: 'Javascript'}));
	}
}
function copyToClipboard() {
  //the whole dom only has one #share-input, in the modal so this will grab the input value
	let copyText = document.getElementById('share-input').textContent;
   /* Copy the text inside the text field */
  if(copyText.length > 0) {
    navigator.clipboard.writeText(copyText.value).then(function() {
      /* clipboard successfully set */
      jQuery('.toast').toast('show');
    }, function() {
      /* clipboard write failed */
      console.log('failed')
    });
  }
  
} 

window.addEventListener('DOMContentLoaded', (event) => {
	updateTabIndices();
	let shareTriggers = document.querySelectorAll('.share-resource-trigger');

	if(shareTriggers.length > 0) {
		shareTriggers.forEach(function(element) {
			element.addEventListener('click', function(e) {
				//set #shareInput to be the value of data-resource-link
				let shareLink = e.target.dataset.shareLink;
				let shareInput = document.querySelector('#share-input');
				shareInput.textContent = shareLink; 
			});
		});
	}
	if(document.querySelector('.copy-btn')) {
		let copyBtn = document.querySelector('.copy-btn');
		copyBtn.addEventListener('click', function(event) {
			event.preventDefault();
			// doesn't need any arguments, it will grab the value of #shareInput
			copyToClipboard();
		});
	}
	function handleAudioPlayback(audioField, audioElement) {
		let currentLang = document.documentElement.lang;
		
    audioElement.addEventListener('ended', function() {
      audioField.classList.remove('playing');
			if(currentLang.includes('en')) {
				audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Play Audio', {}, {context: 'Javascript'});
			} else {
				audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Reproducir audio', {}, {context: 'Javascript'});
			}
    });
    audioElement.addEventListener('pause', function() {
      audioField.classList.remove('playing');
			if(currentLang.includes('en')) {
      	audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Play Audio', {}, {context: 'Javascript'});
			} else {
				audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Reproducir audio', {}, {context: 'Javascript'});
			}
    });
    if(audioField.classList.contains('playing')) {
        audioElement.pause();
        audioElement.currentTime = 0;
        audioField.classList.remove('playing');
    } else {
        audioField.classList.add('playing');
				if(currentLang.includes('en')) {
					audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Pause Audio', {}, {context: 'Javascript'});
				}
				else {
					audioField.querySelector('.purple-play-btn-text').innerHTML = Drupal.t('Pausar audio', {}, {context: 'Javascript'});
				}
        audioElement.play();
    }
	}
	if(document.querySelector('#english-reflection-play-btn')) {
		let englishAudioButtons = document.querySelectorAll('#english-reflection-play-btn');
		englishAudioButtons.forEach(function(button) {
			// relatedAudio is going to be in a sibling div beneath the audio-placeholder-wrapper
			let relatedAudio = button.nextElementSibling.querySelector('audio');
			button.addEventListener('click', function(event) {
				event.preventDefault();
				handleAudioPlayback(button, relatedAudio);
			});
		});
	}
});